import React, {Component} from 'react';
import { Link, withRouter } from 'react-router-dom';
import $ from 'jquery';
import contractsData from '../data/contracts.json';

class Header extends Component {
	constructor(props){
		super(props);
		this.state = {
			search: this.props.match.params.search ? this.props.match.params.search : ``
		}

		this.handleChange = this.handleChange.bind(this);
	}

	componentDidMount() {
		let ww = $(window).width();
		if(ww < 992) {
			$('.nav-link[href="/contracts"], .dropdown-item').on('click', function(){ 
		        if($('.navbar-toggle').css('display') !== 'none'){
		            $(".navbar-toggler").trigger( "click" );
		        }
		    });
		}
	}

	handleChange(e) {

		const target = e.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.name;

		let s = value ? value : "All Contracts"

		this.setState({
			[name]: value
		}, ()=>{
			this.props.history.push("/search/"+s.replace(/\s+/g, '-').toLowerCase());
		})
	}

	handleSubmit(e){
		e.preventDefault();
	}

	render() {
		return (
			<div className="header">
				<nav className="navbar navbar-expand-lg navbar-light">
					<Link to="/" className="navbar-brand">
						<div className="logo">
							<h1>Contracts<span>.ph</span></h1>
							<span className="beta">beta</span>
						</div>
					</Link>
					<button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
	    				<span className="navbar-toggler-icon"></span>
	  				</button>

					<div className="collapse navbar-collapse" id="navbarSupportedContent">

						{/* Main navigation */}
						<ul className="navbar-nav ml-auto">
							<li className="nav-item dropdown">
								<Link to="/contracts/real-estate" className="nav-link dropdown-toggle" id="navbarDropdownRealEstate" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
									Real Estate
								</Link>
								<div className="dropdown-menu" aria-labelledby="navbarDropdown">
									<Link to="/contracts/real-estate/contract-to-sell" className="dropdown-item" data-toggle="tooltip" data-placement="right" title={contractsData.contracts[0].category["Real Estate"][0].description}>Contract to Sell</Link>
									<Link to="/contracts/real-estate/deed-of-absolute-sale" className="dropdown-item" data-toggle="tooltip" data-placement="right" title={contractsData.contracts[0].category["Real Estate"][1].description}>Deed of Absolute Sale</Link>
									<Link to="/contracts/real-estate/real-estate-mortgage" className="dropdown-item" data-toggle="tooltip" data-placement="right" title={contractsData.contracts[0].category["Real Estate"][2].description}>Real Estate Mortgage</Link>
									<Link to="/contracts/real-estate" className="dropdown-item">View All</Link>
								</div>
							</li>
							<li className="nav-item dropdown">
								<Link to="/contracts/free-contracts" className="nav-link dropdown-toggle" id="navbarDropdownFreeContracts" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
									<strong>FREE</strong> Contracts
								</Link>
								<div className="dropdown-menu" aria-labelledby="navbarDropdownFreeContracts">
									<Link to="/contracts/free-contracts/board-resolution-to-sell" className="dropdown-item" data-toggle="tooltip" data-placement="right" title={contractsData.contracts[1].category["Free Contracts"][0].description}>Board Resolution (to Sell)</Link>
									<Link to="/contracts/free-contracts/earnest-money-agreement" className="dropdown-item" data-toggle="tooltip" data-placement="right" title={contractsData.contracts[1].category["Free Contracts"][1].description}>Earnest Money Agreement</Link>
									<Link to="/contracts/free-contracts/option-contract" className="dropdown-item" data-toggle="tooltip" data-placement="right" title={contractsData.contracts[1].category["Free Contracts"][2].description}>Option Contract</Link>
									<Link to="/contracts/free-contracts/secretary-certificate-to-sell" className="dropdown-item" data-toggle="tooltip" data-placement="right" title={contractsData.contracts[1].category["Free Contracts"][3].description}>Secretary's Certificate (to sell)</Link>
									<Link to="/contracts/free-contracts/special-power-of-attorney-to-sell" className="dropdown-item" data-toggle="tooltip" data-placement="right" title={contractsData.contracts[1].category["Free Contracts"][4].description}>Special Power of Attorney (to sell)</Link>
									<Link to="/contracts/free-contracts" className="dropdown-item">View All</Link>
								</div>
							</li>
							<li className="nav-item dropdown">
								<Link to="/contracts/business" className="nav-link dropdown-toggle" id="navbarDropdownBusiness" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
									Business
								</Link>
								<div className="dropdown-menu" aria-labelledby="navbarDropdownBusiness">
									<Link to="/contracts/business/promissory-note" className="dropdown-item" data-toggle="tooltip" data-placement="right" title={contractsData.contracts[2].category["Business"][0].description}>Promissory Note</Link>
									<Link to="/contracts/business/deed-of-sale-of-motor-vehicle" className="dropdown-item" data-toggle="tooltip" data-placement="right" title={contractsData.contracts[2].category["Business"][1].description}>Deed of Sale of Motor Vehicle</Link>
									<Link to="/contracts/business" className="dropdown-item">View All</Link>
								</div>
							</li>
							<li className="nav-item">
								<Link to="/contracts" className="nav-link">All Contracts</Link>
							</li>
						</ul>

						{/* Search form */}
						<form className="header-form form-inline my-2 my-lg-0 hidden-md-down" onSubmit={this.handleSubmit.bind(this)}>
							<div className="input-group">
								<input className="form-control" name="search" type="search" placeholder="Search" aria-label="Search" onChange={this.handleChange} value={this.state.search} />
								<span className="input-group-btn">
									<button className="btn my-2 my-sm-0 default h-100" type="submit"><i className="fa fa-search" aria-hidden="true"></i></button>
								</span>
							</div>
						</form>

					</div>

				</nav>
			</div>
		);
	}
}

export default withRouter(Header);


// WEBPACK FOOTER //
// ./src/view/Header.js